import type { JourneyOperationalAction } from './journey-radar';
import { formatRelativeDate } from './formatters';

export function actionRecommendation(action: JourneyOperationalAction) {
  if (action.policy?.state === 'changes_requested')
    return 'Open the pull request and address the requested changes.';
  if (action.policy?.state === 'unknown')
    return 'Check the GitHub App permissions for this repository.';
  if (action.policy)
    return `Request approval from ${action.requiredOwners.join(', ') || 'a repository reviewer'}.`;
  if (action.category === 'failure')
    return `Open the failed ${action.stageLabel.toLowerCase()} run and fix the failing step.`;
  if (action.category === 'missing_evidence') {
    return action.url?.includes('/pull/')
      ? 'Open the pull request and check its latest run.'
      : 'Open the related run and check its latest result.';
  }
  if (action.category === 'human_action')
    return `Complete the ${action.stageLabel.toLowerCase()} step.`;
  if (action.category === 'stale')
    return 'Resume this work or close it if it is no longer needed.';
  if (action.category === 'divergence')
    return 'Link the missing task, code change or delivery record.';
  if (action.category === 'external_wait')
    return `Check ${action.stageLabel.toLowerCase()} in the connected service.`;
  return 'Open the linked work and choose who will take the next step.';
}

export function actionLinkLabel(action: JourneyOperationalAction) {
  if (action.policy) return 'Open pull request';
  if (action.category === 'failure') return 'Open failed run';
  if (action.category === 'missing_evidence') {
    return action.url?.includes('/pull/')
      ? 'Open pull request'
      : 'Open related run';
  }
  if (action.category === 'external_wait') return 'Open provider';
  return 'Open source';
}

export function actionStateLabel(action: JourneyOperationalAction) {
  if (action.waitingOn === 'human') return 'Decision needed';
  if (action.waitingOn === 'external') return 'Waiting outside Cindro';
  if (action.category === 'failure') return 'Automation failed';
  if (action.category === 'missing_evidence') return 'Result missing';
  return 'Waiting for automation';
}

export function formatAttentionDetail(detail: string) {
  const overdueMatch = detail.match(
    /^(.+?) was expected by (\d{4}-\d{2}-\d{2}T[^ ]+) but has not completed\.$/
  );
  if (!overdueMatch) return detail;
  const relative = formatRelativeDate(overdueMatch[2]);
  return relative.startsWith('in ')
    ? `${overdueMatch[1]} is expected ${relative}.`
    : `${overdueMatch[1]} is ${relative.replace(/ ago$/, '')} overdue.`;
}
